import * as React from "react";

const SvgIcnGreenIndicator = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 12 12" {...props}>
        <circle cx={4} cy="50%" r={4} fill="#19BD3A" stroke="none" strokeWidth={1} fillRule="evenodd" />
    </svg>
);

export default SvgIcnGreenIndicator;

SvgIcnGreenIndicator._raw = `
<svg width="1em" height="1em" viewBox="0 0 12 12" >
        <circle cx="4" cy="50%" r="4" fill="#19BD3A" stroke="none" strokeWidth="1" fillRule="evenodd" />
    </svg>`;
